import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { FormikValues } from 'formik'

import { i18WithParams as t } from '@shared/locale'
import { Hooks, Types } from 'service-api'
import { useParams } from 'react-router-dom'
import { useMemo } from 'react'

interface TPetInstructionsFormProps {
  formik: FormikValues
  lpp?: Types.LocationPetProfileClientDto
}

export const PetInstructionsForm = ({ formik }: TPetInstructionsFormProps) => {
  const { accountName: locationName = '' } = useParams()
  const serviceTypes = Hooks.useClientLocationServiceType(locationName)

  const hasGrooming = useMemo(() => {
    if (serviceTypes.isSuccess) {
      return serviceTypes.data.results.some((serviceType) => serviceType.serviceType?.name === 'grooming')
    } else {
      return false
    }
  }, [serviceTypes.data, serviceTypes.isSuccess])

  return (
    <>
      <a id="instructions" />
      <Typography variant="h6" sx={{ mt: 1, mb: 3 }}>
        {t('profile.pet.form.instructions.title')}
      </Typography>

      <TextField
        id="clientFeedingInstruction"
        label={t('profile.pet.form.feedingInstruction')}
        variant="outlined"
        sx={{ flex: 1, mb: 3 }}
        value={formik.values.clientFeedingInstruction}
        onChange={formik.handleChange}
        error={formik.touched.clientFeedingInstruction && Boolean(formik.errors.clientFeedingInstruction)}
        helperText={formik.touched.clientFeedingInstruction && formik.errors.clientFeedingInstruction}
        fullWidth
        multiline
        maxRows={8}
      />

      <TextField
        id="clientMedicationInstruction"
        label={t('profile.pet.form.medicationInstruction')}
        variant="outlined"
        sx={{ flex: 1, mb: 3 }}
        value={formik.values.clientMedicationInstruction}
        onChange={formik.handleChange}
        error={formik.touched.clientMedicationInstruction && Boolean(formik.errors.clientMedicationInstruction)}
        helperText={formik.touched.clientMedicationInstruction && formik.errors.clientMedicationInstruction}
        fullWidth
        multiline
        maxRows={8}
      />

      <TextField
        id="clientCareInstruction"
        label={t('profile.pet.form.careInstruction')}
        variant="outlined"
        sx={{ flex: 1, mb: 3 }}
        value={formik.values.clientCareInstruction}
        onChange={formik.handleChange}
        error={formik.touched.clientCareInstruction && Boolean(formik.errors.clientCareInstruction)}
        helperText={formik.touched.clientCareInstruction && formik.errors.clientCareInstruction}
        fullWidth
        multiline
        maxRows={8}
      />

      {hasGrooming ? (
        <TextField
          id="clientGroomingInstruction"
          label={t('profile.pet.form.groomingInstruction')}
          variant="outlined"
          sx={{ flex: 1, mb: 0 }}
          value={formik.values.clientGroomingInstruction}
          onChange={formik.handleChange}
          error={formik.touched.clientGroomingInstruction && Boolean(formik.errors.clientGroomingInstruction)}
          helperText={formik.touched.clientGroomingInstruction && formik.errors.clientGroomingInstruction}
          fullWidth
          multiline
          maxRows={8}
        />
      ) : null}
    </>
  )
}
